import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

async function setup(nuxtApp) {
    if (!import.meta.client) {
        nuxtApp.provide('echo', {
            inactive: true,
        });
        return;
    }

    const { public: runtimeConfig } = useRuntimeConfig();
    const { echo: echoConfig, appHost } = runtimeConfig;

    if (!echoConfig.key || !echoConfig.enabled) {
        nuxtApp.provide('echo', {
            inactive: true,
        });

        return;
    }

    const { session, loggedIn } = useUserSession();

    if (!loggedIn.value) {
        nuxtApp.provide('echo', {
            inactive: true,
        });

        return;
    }

    const { $eventbus } = nuxtApp;

    const { accessToken } = session.value;

    const authorizer = (channel, options) => {
        return {
            authorize: async (socketId, callback) => {
                if (!accessToken) {
                    return callback('Not authenticated', null);
                }

                const Authorization = accessToken?.startsWith('Bearer ')
                    ? accessToken
                    : `Bearer ${accessToken}`;

                try {
                    const response = await $fetch(
                        `${appHost}/api/broadcasting/auth`,
                        {
                            method: 'POST',
                            headers: {
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                                Authorization,
                            },
                            body: JSON.stringify({
                                socket_id: socketId,
                                channel_name: channel.name,
                            }),
                        },
                    );

                    callback(null, response);

                    $eventbus?.trigger('echo:authorized', {
                        channel,
                        options,
                    });
                } catch (error) {
                    console.error(error);
                    callback(error, null);
                }
            },
        };
    };

    // Remove protocol from host
    const wsHost =
        echoConfig.wsHost ?? appHost.replace(/^(http|https)?:\/\//, '');

    const options = {
        debug: true,
        broadcaster: 'reverb',
        // Host and port
        key: echoConfig.key,
        wsHost,
        wsPort: echoConfig.wsPort,
        wssPort: echoConfig.wssPort,
        // Tls/Encryption
        enabledTransports: ['ws', 'wss'],
        encrypted: echoConfig.encrypted,
        forceTLS: echoConfig.forceTls,
        // Auth related options
        authEndpoint: `${runtimeConfig.appHost}/api/broadcasting/auth`,
        authorizer,
    };

    const pusher = new Pusher(runtimeConfig.echo.key, {
        ...options,
        // Http
        httpHost: appHost,
        statsHost: appHost,
        disableStats: echoConfig.disableStats,
        cluster: '',
    });

    const echo = new Echo({
        ...options,
        client: pusher,
    });

    nuxtApp.provide('echo', echo);
}

export default defineNuxtPlugin({
    name: 'echo',
    dependsOn: ['eventbus'],
    setup,
});
